/* eslint-disable eqeqeq */
import { faLongArrowAltDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { resourcesServices } from "Dashboard/scenes/Resources/services/resource.service";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { useAppDispatch } from "hooks/hooks";
import { getResourcesList, setNewResourcePopover } from "../main.slice";
import { toast } from "react-toastify";
import { ICreateResource } from "Dashboard/scenes/Resources/domain/ICreateResource";
import classes from "../../../../../../components/Popover/popover.module.scss";
import classesResources from "../../../styles/NewResourcePopover.module.scss";
import { styles } from "../../../../../../components/Popover/popoverSelectStyle";
import {
  Control,
  Controller,
  FieldErrorsImpl,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormWatch
} from "react-hook-form";
import PartnerSimpleSelect from "Dashboard/scenes/Partners/components/PartnerSimpleSelect";
import EmployeeSelect from "Dashboard/scenes/Resources/components/EmployeeSelect";
import CategorySelect from "Dashboard/scenes/Resources/components/CategorySelect";
import TypeSelect from "Dashboard/scenes/Resources/components/TypeSelect";

interface IProps {
  handleSubmit: UseFormHandleSubmit<ICreateResource>;
  register: UseFormRegister<ICreateResource>;
  control: Control<ICreateResource, any>;
  errors: Partial<FieldErrorsImpl<ICreateResource>>;
  reset: () => void;
  watch: UseFormWatch<ICreateResource>;
};

const NewResourcePopover: React.FC<IProps> = (
  { handleSubmit, register, control, errors, reset, watch }
) => {
  const [quantityMissing, setQuantityMissing] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setNewResourcePopover({ isOpen: false }));
    reset();
  }

  const getIsQuantityMissing = (categoryId: number, quantity: number | undefined): boolean => {
    const quantityValue = Number(quantity);
    const quantityIsRequired = categoryId != 1 && categoryId != 2;
    return quantityIsRequired && (quantityValue <= 0 || Number.isNaN(quantityValue));
  }

  const onSubmit = async (data: ICreateResource) => {
    try {
      if (getIsQuantityMissing(data.categoryId, data.quantity)) {
        toast.error("Morate uneti količinu za ovu kategoriju");
        setQuantityMissing(true);
        return;
      }
      await resourcesServices.createResource(data);
      close();
      dispatch(getResourcesList({}));
      toast.success("Resurs je uspesno dodat.");
    } catch (err) {
      console.error(err);
    }
  };

  const validateQuantity = (): void => {
    setQuantityMissing(getIsQuantityMissing(watch("categoryId"), watch("quantity")));
  }


  return (
    <form onSubmit={handleSubmit(onSubmit)}
      className={`${classesResources.newResourcePopover} ${classes.basicPopover}`}
    >
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>brend, model, tip, naziv</label>
          <input
            type="text" className={`${classes.itemBorder}
            ${errors.name ? classes.itemError : ""}`}
            {...register("name", { required: true })}
          />
        </div>
      </div>
      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>vrsta *</label>
          <Controller
            name="typeId"
            control={control}
            defaultValue={1}
            rules={{ required: true }}
            render={({ field: { onChange } }) => (
              <TypeSelect
                customStyles={styles.customStyleClassic}
                error={errors.typeId}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>kategorija</label>
          <Controller
            name="categoryId"
            control={control}
            defaultValue={1}
            rules={{ required: true }}
            render={({ field: { onChange } }) => (
              <CategorySelect
                customStyles={styles.customStyleClassic}
                error={errors.categoryId}
                onChange={(newValue: number | null) => {
                  onChange(newValue);
                  validateQuantity();
                }}
              />
            )}
          />
        </div>
      </div>

      {(watch("categoryId") == 1 || watch("categoryId") == 2) && (
        <div className={classes.row}>
          <div className={`${classes.col} ${classes.rowDir}`}>
            <label className={classes.mr5}>merna jedinica</label>
            <select className={classes.itemBorder} {...register("usageUnit")}>
              <option value={"H"}>h</option>
              <option value={"KM"}>km</option>
            </select>
          </div>
        </div>
      )}

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>kolicina</label>
          <Controller
            name="quantity"
            control={control}
            defaultValue={undefined}
            rules={{ required: false }}
            render={({ field: { onChange } }) => (
              <input
                type="number"
                className={`${classes.itemBorder} ${errors.quantity || quantityMissing ? classes.itemError : ""}`}
                onChange={(e) => {
                  onChange(e);
                  validateQuantity();
                }}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>dobavljač</label>
          <Controller
            name="supplierPartnerId"
            control={control}
            defaultValue={undefined}
            render={({ field: { onChange } }) => (
              <PartnerSimpleSelect
                customStyles={styles.customStyleClassic}
                error={errors.supplierPartnerId}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>dnevni najam</label>
          <input
            type="text"
            className={`${classes.itemBorder} ${errors.leaseRate ? classes.itemError : ""}`}
            {...register("leaseRate")}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>god.proizvodnje</label>
          <input
            type="text"
            className={`${classes.itemBorder} ${errors.yearOfProduction ? classes.itemError : ""}`}
            {...register("yearOfProduction")}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>br. reg./ ser.br.</label>
          <input
            type="text"
            className={`${classes.itemBorder} 
              ${errors.registrationPlateSerialNumber ? classes.itemError : ""}`}
            {...register("registrationPlateSerialNumber")}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>dat. sled. registracije</label>
          <Controller
            name="nextRegistrationDate"
            control={control}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? date.toISOString().split("T")[0] : null)
                  }
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd.MM.yyyy"
                  selected={value ? new Date(value) : null}
                  className={`${classes.dateItem} ${classes.itemBorder}
                      ${errors.nextRegistrationDate ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>dat. sled. tahografa</label>
          <Controller
            name="nextTachographDate"
            control={control}
            render={({ field: { onChange, value } }) => (
              <div>
                <DatePicker
                  onChange={(date) =>
                    onChange(date ? date.toISOString().split("T")[0] : null)
                  }
                  showMonthDropdown
                  showYearDropdown
                  dateFormat="dd.MM.yyyy"
                  selected={value ? new Date(value) : null}
                  className={`${classes.dateItem} ${classes.itemBorder}
                      ${errors.nextTachographDate ? classes.itemError : ""}`}
                />
              </div>
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={`${classes.col} ${classes.rowDir}`}>
          <label className={classes.mr5}>resurs zaposlenog?</label>
          <Controller
            name="resourceOwnerEmployeeId"
            control={control}
            defaultValue={undefined}
            render={({ field: { onChange } }) => (
              <EmployeeSelect
                customStyles={styles.customStyleClassic}
                error={errors.resourceOwnerEmployeeId}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>

      <div className={classes.row}>
        <div className={classes.buttons}>
          <button className={classes.iconButton} type="submit">
            <FontAwesomeIcon icon={faLongArrowAltDown} className={classes.icon} />
          </button>
        </div>
      </div>
    </form>
  );
};

export default NewResourcePopover;
